export const BASIC_WRAPPER_ID = 'NVL_basic-wrapper';
export const INTERACTIVE_WRAPPER_ID = 'NVL_interactive-wrapper';
